// extracted by mini-css-extract-plugin
export default {"wrap":"NI-z","fullWidth":"OI-z","hideOnDesktop":"PI-z","content":"QI-z","hasOpenedNav":"RI-z","crumbsList":"SI-z","dropdownsWrap":"TI-z"};